/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoyaltyConfigurationDto } from './loyaltyConfigurationDto';


export interface LoyaltyProgramSetupDto { 
    id?: number;
    image?: string;
    extractedText?: string;
    setupResource?: string;
    result?: LoyaltyProgramSetupDto.ResultEnum;
    failedExtractors?: string;
    successfulExtractors?: string;
    loyaltyProgram?: LoyaltyConfigurationDto;
}
export namespace LoyaltyProgramSetupDto {
    export type ResultEnum = 'INCOMPLETE' | 'COMPLETE' | 'ERROR';
    export const ResultEnum = {
        Incomplete: 'INCOMPLETE' as ResultEnum,
        Complete: 'COMPLETE' as ResultEnum,
        Error: 'ERROR' as ResultEnum
    };
}


